/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/neural-networking-audio-analyses.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/neural-networking-audio-analyses.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/neural-networking-audio-analyses.mdx';

const metadata = {
  slug: "neural-networking-audio-analyses",
  title: "Neural Networking Audio Analyses",
  author: "Christian Battaglia",
  description: "Ongoing notes on neural network fundamentals and how they apply to audio analysis — from feedforward networks to radial basis functions, building toward understanding how Spotify's Discover Weekly works under the hood.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-09-16T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["neural networks","audio analysis","Spotify","machine learning","Discover Weekly","feedforward","radial basis","music","data science"],
};

export const Route = createFileRoute('/blog/posts/neural-networking-audio-analyses')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/neural-networking-audio-analyses',
    image: '/og/blog/neural-networking-audio-analyses.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
